import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "react-router-dom";
import { UserRoles } from "constants/userRoles";
import AuthGuard from "context/auth/AuthGuard";
import { EditorContainerBox, LoadingBox } from "components/views/editor/UpdateTrainingPage.styles";
import { useGetLessonWithLatestVersions } from "hooks/useGetLessonWithLatestVersions";
import { LessonType } from "models/LessonType";
import { UpdateVrLessonPage } from "components/views/editor/UpdateVrLessonPage";
import { UpdateGameLessonPage } from "components/views/editor/UpdateGameLessonPage";

export const UpdateTrainingPage = () => {
    const { id } = useParams();
    const { lessonData, fetchLessonWithLatestVersions, loading: fetchLessonPending } =
        useGetLessonWithLatestVersions(id ?? "");

    if (fetchLessonPending || !lessonData) {
        return (
            <AuthGuard requiredRoles={[UserRoles.ADMIN, UserRoles.Patron]}>
                <EditorContainerBox>
                    <LoadingBox>
                        <CircularProgress color="primary" />
                    </LoadingBox>
                </EditorContainerBox>
            </AuthGuard>
        );
    }

    return (
        <AuthGuard requiredRoles={[UserRoles.ADMIN, UserRoles.Patron]}>
            <EditorContainerBox>
                {lessonData.lessonType === LessonType.GAME ? (
                    <UpdateGameLessonPage
                        lessonData={lessonData}
                        fetchLessonWithLatestVersions={fetchLessonWithLatestVersions}
                    />
                ) : (
                    <UpdateVrLessonPage
                        lessonData={lessonData}
                        fetchLessonWithLatestVersions={fetchLessonWithLatestVersions}
                    />
                )}
            </EditorContainerBox>
        </AuthGuard>
    );
};
